import type { SVGProps } from 'react';
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <desc>{'Arrow Right Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M.75 12h22.5M12.75 22.5 23.25 12 12.75 1.5"
    />
  </svg>
);
export default SvgArrowRight;
